import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section id="latest" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-2">最新更新</h2>
            <p className="text-sm text-foreground-500">持续更新的哺乳育儿漫画内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-full whitespace-nowrap">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{article.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-heading text-foreground-800 mb-2 group-hover:text-accent-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4">
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                  <span className="text-xs text-accent-500 font-medium whitespace-nowrap group-hover:translate-x-1 transition-transform inline-flex items-center gap-1">
                    阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}